// ACCOUNT
export const REQUEST_AUTH_DATA = 'REQUEST_AUTH_DATA'
export const RECEIVE_AUTH_DATA = 'RECEIVE_AUTH_DATA'
export const RESET_AUTH_DATA = 'RESET_AUTH_DATA'
export const RECEIVE_ACCESSIBLE_ACCOUNTS = 'RECEIVE_ACCESSIBLE_ACCOUNTS'
export const SET_CURRENT_ACCOUNT = 'SET_CURRENT_ACCOUNT'

// ORDERS
export const REQUEST_ORDERS = 'REQUEST_ORDERS'
export const ON_ORDERS_CHANGE = 'ON_ORDERS_CHANGE'

// CLIENTS
export const REQUEST_CLIENTS = 'REQUEST_CLIENTS'
export const ON_CLIENTS_CHANGE = 'ON_CLIENTS_CHANGE'

// CLIENTS
export const REQUEST_PRODUCTS = 'REQUEST_PRODUCTS'
export const ON_PRODUCTS_CHANGE = 'ON_PRODUCTS_CHANGE'


export const RESET_ACCOUNT_DATA = 'RESET_ACCOUNT_DATA'



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/actions/types.js